import { Button } from '../../../../../components/button/button';
import { Page } from '../../../../../components/page/page';
import s from './create-promo.module.css';
import { PromoSettings } from './steps/settings/promo-settings';
import { PromoView } from './steps/view/view';
import { useCreatePromo } from './use-create-promo';

export const CreatePromo = () => {
  const { handleNext, isLoading, id, t, isEdit } = useCreatePromo();

  return (
    <Page className={s.page}>
      <h2 className={s.title}>{t(isEdit ? 'Изменить акцию' : 'Создать акцию')}</h2>
      <div className={s.container}>
        <div className={s.editor}>
          <PromoSettings />
          {id ? <PromoView /> : t('Сначала создайте акцию')}
        </div>
        <div className={s.controls}>
          <Button variant="secondary" hrefBack disabled={isLoading} data-testid="back-button">
            {t('Назад')}
          </Button>
          <Button
            variant="primary"
            onClick={handleNext}
            disabled={isLoading}
            data-testid="submit-button"
          >
            {t(isEdit ? 'Изменить' : 'Создать')}
          </Button>
        </div>
      </div>
    </Page>
  );
};
